// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3ljMd","content":"LayoutSettings_content__2un1R"};